// Libs
import './libs/bootstrap/css/bootstrap.min.css'
import './libs/toastr/toastr.min.css'
import './libs/animate/animate.min.css'

// Template
import './template/template.css'
import './template/fonts.css'
import './template/skin.css'

// Framework
import './fw/components/label.css'
import './fw/controls/switch.css'
import './fw/controls/triStateSwitch.css'
import './fw/controls/auto.css'
import './fw/controls/multiselect.css'
import './fw/controls/select.css'
import './fw/controls/fileUpload.css'
import './fw/controls/dateTime.css'
import './fw/controls/avatar.css'
import './fw/controls/arrowCombo.css'
import './fw/controls/searchBox.css'
import './fw/general/validations.css'
import './fw/general/general.css'

// App
import './app/layout/header.css'
import './app/layout/menu.css'
import './app/layout/userCard.css'
import './app/overrides/overrides.css'
import './app/pages/audit.css'
import './app/pages/login.css'
import './app/pages/registration.css'
import './app/pages/profile.css'
import './app/pages/roleSetup.css'
import './app/pages/search.css'
import './app/pages/welcome.css'
import './app/pages/certificationDashboard.css'
import './app/layout/help.css'



// WEBPACK FOOTER //
// ./src/css/styles.js